(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Stigg", [], factory);
	else if(typeof exports === 'object')
		exports["Stigg"] = factory();
	else
		root["Stigg"] = factory();
})(this, function() {
return 